const ADAPTIV_EVENT_PREFIX = 'adaptiv_';

const cleanPayload = (payload = {}) =>
  Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

const track = (eventName, payload = {}) => {
  const name = eventName.startsWith(ADAPTIV_EVENT_PREFIX) ? eventName : `${ADAPTIV_EVENT_PREFIX}${eventName}`;
  const detail = cleanPayload({
    event: name,
    page_type: document.body?.dataset?.adaptivPageType,
    template: document.body?.dataset?.adaptivTemplate,
    path: window.location.pathname,
    ...payload,
  });

  window.dispatchEvent(new CustomEvent('adaptiv:track', { detail }));

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(detail);
};

const closestTrackable = (target) => target?.closest?.('[data-adaptiv-track]');

const datasetPayload = (element) => ({
  location: element.dataset.adaptivTrackLocation,
  label: element.dataset.adaptivTrackLabel || element.textContent?.trim(),
  product_id: element.dataset.adaptivProductId,
  product_handle: element.dataset.adaptivProductHandle,
  product_type: element.dataset.adaptivProductType,
  collection_handle: element.dataset.adaptivCollectionHandle,
  destination: element.getAttribute('href') || element.dataset.adaptivDestination,
});

document.addEventListener(
  'click',
  (event) => {
    const element = closestTrackable(event.target);
    if (!element) return;

    track(element.dataset.adaptivTrack || 'click', datasetPayload(element));
  },
  { passive: true }
);

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!form?.matches?.('[data-adaptiv-track-form]')) return;

  const interest = form.querySelector('[data-adaptiv-lead-interest]')?.value;
  const priority = form.querySelector('[data-adaptiv-lead-priority]')?.value;
  const sms = form.querySelector('[data-adaptiv-lead-sms]')?.checked;

  track(form.dataset.adaptivTrackForm || 'lead_submit', {
    location: form.dataset.adaptivTrackLocation,
    lead_interest: interest,
    lead_priority: priority,
    sms_interest: sms === undefined ? undefined : sms ? 'yes' : 'no',
  });
});

window.AdaptivAnalytics = window.AdaptivAnalytics || { track };
